import history from '../history'
import * as authentication from '../authentication'

history.listen(async (location) => {
  await window.gtag('config', process.env.GOOGLE_ANALYTICS_ID, {
    send_page_view: false
  })

  const token = authentication.getAccessToken()

  if (token) {
    const userId = authentication.getUserId()
    await window.gtag('config', process.env.GOOGLE_ANALYTICS_ID, {
      user_id: userId,
      send_page_view: false
    })
  }

  await window.gtag('event', 'screen_view', {
    screen_name: location.pathname
  })
})
